import { render, staticRenderFns } from "./IndexHyData1.vue?vue&type=template&id=c2bf5bf6"
import script from "./IndexHyData1.vue?vue&type=script&lang=js"
export * from "./IndexHyData1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports